/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraServiceManagementBudgetAlertsMapping extends models.JiraServiceManagementMappingBase {
    getFixupPrototypeFunction() { return JiraServiceManagementBudgetAlertsMapping.fixupPrototype; }

    static newInstance(model: Partial<JiraServiceManagementBudgetAlertsMapping>): JiraServiceManagementBudgetAlertsMapping {
        let obj = Object.assign(new JiraServiceManagementBudgetAlertsMapping(), model);
        JiraServiceManagementBudgetAlertsMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraServiceManagementBudgetAlertsMapping>): JiraServiceManagementBudgetAlertsMapping {
        if (!model) return null;
        return JiraServiceManagementBudgetAlertsMapping.newInstance(<JiraServiceManagementBudgetAlertsMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraServiceManagementBudgetAlertsMapping) {
        if (!obj) return;

        models.JiraServiceManagementBudgetAlertsMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraServiceManagementBudgetAlertsMapping): boolean {
        if (models.JiraServiceManagementMappingBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, JiraServiceManagementBudgetAlertsMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.attribute_mappings) {
            for (let val of this.attribute_mappings) {
                models.JiraServiceManagementIncidentManagementConfigurationMappingForBudgetAlerts.fixupPrototype(val);
            }
        }
    }

    /**
     * List of Budget Alert attribute enums.
     */
    description_attributes: Array<models.DescriptionAttributeForItsmBudgetAlert>;

    /**
     * List of Budget Alert attribute mappings.
     */
    attribute_mappings: Array<models.JiraServiceManagementIncidentManagementConfigurationMappingForBudgetAlerts>;

}
